import React from "react";
import { object, number } from "prop-types";

import StoryElements from "../story-elements";
import StorySideBar from "../story-sidebar-elements";
import VideoHeaderBlock from "./video-header-block";
import MovieRating from "../story-elements/movie-rating";

import "./video.m.css";

const getPrimaryVideo = (cards) => {
  const headerVideo = [];
  cards.forEach((card) => {
    card["story-elements"].forEach((element) => {
      if (element.type === "youtube-video" || element.subtype === "dailymotion-video") {
        headerVideo.push(element);
      }
    });
  });
  return headerVideo[0];
};

const getCards = (cards, id) => {
  let storyCards = [];
  cards.forEach((card) => {
    const newCard = Object.assign({}, card);
    let elements = [];
    card["story-elements"].map((element) => {
      if (element.id !== id) {
        elements = [...elements, element];
      }
    });
    newCard["story-elements"] = elements;
    storyCards = [...storyCards, newCard];
  });
  return storyCards;
};

const VideoStory = ({ story, index }) => {
  let primaryVideo = null;
  let cards = story.cards;

  const isReview = story["story-template"] === "review";

  if (!isReview) {
    primaryVideo = getPrimaryVideo(story.cards);
    cards = primaryVideo ? getCards(story.cards, primaryVideo.id) : story.cards;
  }


  return (
    <div styleName="wrapper">
      <VideoHeaderBlock story={story} primaryVideo={primaryVideo} isReview={isReview} index={index} />

      <div styleName="story-body">
        <div>
          {isReview && <MovieRating metadata={story.metadata} />}
          <StoryElements story={story} cards={cards} index={index} />
        </div>
        <StorySideBar index={index} story={story} />
      </div>
    </div>
  );
};

VideoStory.propTypes = {
  story: object,
  index: number,
};

export default VideoStory;
